import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Button, Nav } from 'react-bootstrap';
import ServiceCenterManager from './ServiceCenterManager';
import ProductManager from './ProductManager';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [activeView, setActiveView] = useState('service-centers');

  useEffect(() => {
    // Check if the user is logged in
    if (localStorage.getItem('isAdminLoggedIn') !== 'true') {
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('isAdminLoggedIn');
    navigate('/admin/login');
  };

  return (
    <Container className="py-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Admin Dashboard</h1>
        <Button variant="danger" onClick={handleLogout}>Logout</Button>
      </div>

      <Nav variant="tabs" defaultActiveKey="service-centers" onSelect={(selectedKey) => setActiveView(selectedKey)}>
        <Nav.Item>
          <Nav.Link eventKey="service-centers">Service Centers</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="products">Products</Nav.Link>
        </Nav.Item>
      </Nav>

      <div className="mt-4">
        {activeView === 'service-centers' && <ServiceCenterManager />}
        {activeView === 'products' && <ProductManager />}
      </div>
    </Container>
  );
};

export default AdminDashboard;
